import { createBrowserRouter } from 'react-router-dom';
import App from './App';
import { setRouter } from './navigation';

/*
 * Single catch-all route delegating to the existing ContentArea route tree
 * (rendered inside <App/>). Created at module scope so out-of-component code can
 * navigate before React mounts. basename is configured so deep links / QR-SMS links
 * / the /mobile alias resolve unchanged.
 */
export const router = createBrowserRouter([{ path: '*', element: <App /> }], {
    basename: process.env.REACT_APP_BASENAME || undefined,
});

setRouter(router);
